<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'首页推荐管理管理'},{name:'融资产品推荐列表',goback:true},{name:'添加融资产品推荐'}]" :title="'添加融资产品推荐'"/>
            <!-- 表单 -->
            <div class="box">
                <div class="forms">
                    <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="产品名称"
            prop="sourceId"
            class="formitem"
          >
            <el-select
              v-model="ruleForm.sourceId"
              placeholder="请选择产品名称"
              filterable
              clearable
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item,index) in newsDataSelect"
                :key="index"
                @click.native="chooseItem(item)"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="贷款类型">
            <el-input
              disabled
              v-model="ruleForm.type"
            ></el-input>
          </el-form-item>
          <el-form-item label="银行名称">
            <el-input
              disabled
              v-model="ruleForm.bankName"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="序号"
            prop="sort"
          >
            <el-input v-model="ruleForm.sort"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary" size="small"
              @click="submitForm('ruleForm')"
            >确认</el-button>
            <el-button @click="resetForm('ruleForm')" size="small">取消</el-button>
          </el-form-item>
        </el-form>
                </div>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import upLoad from '../../components/upLoad'
import {getDict} from "@/axios";
export default {
    components:{
        breadcrumb,
        upLoad
    },
    data(){
        return{
            statusList: [],//服务类型
			id:'',
           ruleForm: {
                bankName: void 0,
                sort: void 0,
                sourceId: void 0,
                type: void 0,
                name:'',
                bankLogo:void 0,
            },
            rules: {
                sort: [
                    { required: true, message: '请输入序号', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (this.$reg.numPint.test(value) == false) {
                                callback(new Error('请输入正整数'))
                            } else {
                                return callback()
                            }
                        },
                        trigger: 'blur',
                    },
                ],
                sourceId:{ required: true, message: '请选择产品名称', trigger: 'change' }
            },
            newsDataSelect:[]
			
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        }
    },
	created() {
		// /backstage/sysDict/parentId
		this.getSelect()
    const {id} = this.$route.params
		if(id){
		    this.id=id;
			  this.ruleForm.sourceId=id;
			  // this.getDetail();
		}
		
	},
   
    methods:{
      chooseItem(data){
        console.log(data)
        this.ruleForm = Object.assign(this.ruleForm,data)
      },
      async getSelect() {
            const {code,data,msg} = await this.$axiosc.get('backstage/hotProduct/select', {})
            if (code == 200) {
                    this.newsDataSelect = data || [];
                } else {
                    this.$alert(msg)
                }

        },
		getDetail(){
			this.$axiosc.get('backstage/intermediary/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
					let	sendInfo={
					    "intermediaryServiceId": r.data.id,//中介服务ID，编辑时必传
					    "logo": r.data.logo,
					    "name": r.data.name,//中介服务名称
					    "serviceType": r.data.serviceType,//服务类型
					    "summary": r.data.summary,//简介
					    "websiteLink": r.data.websiteLink,//网址链接
						contactPerson:r.data.contactPerson,//联系人
						contactNumber:r.data.contactNumber,//联系人电话
					}
					this.sendInfo=sendInfo;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //提交
        submitForm(formName) {
            const that = this
            that.$refs[formName].validate((valid) => {
                if (valid) {
                    that.$axioscBody.post('/backstage/hotProduct/add', that.ruleForm).then(async (r) => {
                            if (r.code == 200) {
                                that.$message({
                                    type: 'success',
                                    message: r.msg
                                });
                                that.resetForm(formName)
                            } else {
                                that.$alert(r.msg)
                            }
                        })

                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.ruleForm={
                sort: null,
                sourceId:null,
                type:null,
            }
            this.$refs[formName].resetFields();
            this.$router.back(-1);
        },
    }
}
</script>

<style lang="scss" scoped>
.warp{
     height:96%;
     overflow-x: hidden;
     overflow-y: auto;
    .box{
        padding-top: 50px;
        .forms{
            max-width: 650px;
            margin: auto;
            .child{
                .content{
                    flex: 1;
					.el-textarea{
						width: 100% !important;
					}
                }
				/deep/ .el-select{
					width: 100% !important;
				}
				
				.name{
					width: 150px !important;
					text-align: right;
				}
            }
			.hint{
				padding-left: 100px;
			}
			.singleBtn{
				text-align: center;
			}
			.error{
				padding-left: 100px;
			}
        }
    }
}
</style>